(function () {
    $(document).ready(function () {
        var form = $('#bookNowForm');

        var splitted = window.location.href.split('/');


        setTimeout(function () {
            var form = $('#bookNowForm'),
                stepsCont = $('#bookNowForm>div');
            initTimeOut(1000 * 60 * 10);
            form && stepsCont.steps({
                headerTag: 'h3',
                bodyTag: 'section',
                transitionEffect: 'slideLeft',

                labels: {
                    finish: 'Confirm payment & book trip'
                },
                onInit: function (event, currentIndex) {
                    $('#expiration_date').combodate({
                        minYear: 2018,
                        maxYear: 2100,
                        value: new Date()
                    });
                },
                onStepChanging: function (event, currentIndex, newIndex) {
                    $('.alert-message').hide();
                    var move = false;

                    if (currentIndex == 0 && newIndex == 1) {
                        // First step
                        var $form = $("#bookNowForm");
                        move = false;

                        if ($form.valid() == true) {
                            $.ajax({
                                type: 'POST',
                                url: '/book-trip',
                                async: false,
                                data: $form.serialize(),
                                success: function (data) {
                                    if (data.status == 'success') {
                                        $('.alert-message').removeClass('alert-warning alert-danger').addClass('alert-success').show();

                                        $('#id_client').val(data.ids);
                                        $('#email_client').val(data.emails);

                                        $('.alert-text').html('');
                                        $.each(data.message, function (key, value) {
                                            $('.alert-text').append(value);
                                        });

                                        updatePayment();

                                        move = true;
                                    } else {
                                        $('.alert-message').removeClass('alert-warning alert-success').addClass('alert-danger').show();

                                        $('.alert-text').html('');
                                        $.each(data.message, function (key, value) {
                                            $('.alert-text').append(value);
                                        });

                                        move = false;
                                    }
                                }
                            });
                        }
                    }


                    if (currentIndex == 1 && newIndex == 2) {
                        $('.amount-payed-now').html($('#card_holder_payment').val());
                        $('#trip_save_spot').attr('disabled', true);
                        return form.valid();
                    }

                    if (currentIndex == 2 && newIndex == 1) {
                        $('#trip_save_spot').attr('disabled', false);
                    }

                    // Always allow previous action even if the current form is not valid!
                    if (currentIndex > newIndex) {
                        return true;
                    }

                    // Needed in some cases if the user went back (clean up)
                    if (currentIndex < newIndex) {
                        // To remove error styles
                        form.find('.body:eq(' + newIndex + ') label.error').remove();
                        form.find('.body:eq(' + newIndex + ') .error').removeClass('error');
                    }

                    form.validate().settings.ignore = ":disabled,:hidden";

                    return move;
                },
                onStepChanged: function (event, currentIndex, priorIndex) {
                    if (currentIndex == 2) {
                        // Get travelers data
                        var travelersIds = {
                            ids: $('#id_client').val()
                        };

                        $.ajax({
                            type: 'GET',
                            url: '/travelers',
                            data: travelersIds,
                            success: function (data) {
                                if (data.status == 'success') {
                                    $('.travelers').html(data.data);
                                } else {
                                    $('.alert-message').removeClass('alert-warning alert-success').addClass('alert-danger').show();

                                    $('.alert-text').html('');
                                    $.each(data.message, function (key, value) {
                                        $('.alert-text').append(value);
                                    });
                                }
                            }
                        });
                    }
                },
                onFinishing: function (event, currentIndex) {

                    var $form = $('#bookNowForm'),
                        buttonPrev = $('.actions > ul > li').first(),
                        buttonFinish = $('.actions > ul > li').last();

                    buttonPrev.hide();
                    buttonFinish.hide();
                    $('.alert-message').removeClass('alert-danger alert-success').addClass('alert-warning');
                    $('.alert-text').html('The payment is being processed... Please wait!');
                    $('.alert-message').show();
                    initStripe(function () {
                        $.ajax({
                            type: 'POST',
                            url: '/add-payment',
                            data: $form.serialize(),
                            success: function (data) {
                                if (data.status == 'success') {
                                    $('.alert-message').removeClass('alert-warning alert-danger').addClass('alert-success').show();

                                    $('.alert-text').html('');
                                    $.each(data.message, function (key, value) {
                                        $('.alert-text').append(value);
                                    });

                                    setTimeout(function () {
                                        clearView();
                                        $('.alert-message').hide();
                                        // $('#tripsContent').empty();
                                        onChangeTripDates();
                                        buttonPrev.show();
                                        buttonFinish.show();
                                        // form.steps('reset');
                                        $('#bookNowForm')[0].reset();

                                        $('.steps').css('display', 'none');
                                        $('.before-payment').css('display', 'none');
                                        $('.after-payment').css('display', 'block');
                                        $('.modal .actions ul li').remove();
                                        $('.modal .actions ul').css('justify-content', 'center');
                                        $('.modal .actions ul').append('<li class="close"><a>Close</a></li>');
                                        $('.modal .actions ul .close').on('click', function () {
                                            $.modal.close();
                                            $('.booked').show();
                                        });
                                        
                                        // track purchase
                                        var transactionId = $('#stripe_token').val(),
                                            price = $('#trip_price').val(),
                                            noPersons = $('#persons_nr').val(),
                                            totalPrice = price * noPersons,
                                            name = $('#trip_name').val(),
                                            from = $('#trip_departure_location').val(),
                                            tripDate = $('#trip_date').val();
                                        
                                        window.dataLayer = window.dataLayer || [];
                                        dataLayer.push({
                                            'transactionId': transactionId,
                                            'transactionTotal': totalPrice,
                                            'transactionProducts': [{
                                                'sku': tripDate,
                                                'name': name,
                                                'category': from,
                                                'price': price,
                                                'quantity': noPersons
                                            }]
                                        });
                                        
                                    }, 2000);
                                } else {
                                    $('.alert-message').removeClass('alert-warning alert-success').addClass('alert-danger').show();

                                    $('.alert-text').html("");
                                    $.each(data.message, function (key, value) {
                                        $('.alert-text').append(value);
                                    });
                                    buttonPrev.show();
                                    if (data.code != "undefined" && data.code != "mail-error") {
                                        buttonFinish.show();
                                    }
                                }
                            },
                        });
                    });
                }
            });
            form.validate({
                errorPlacement: function errorPlacement(error, element) {
                    element.after(error);
                },
                rules: {
                    'telefon[0]': {
                        phoneValidation: true
                    },
                    'email[0]': {
                        emailValidation: true
                    }
                }
            });
        }, 1000);

        /**
         * Phone validation method
         */
        $.validator.addMethod('phoneValidation', function (phone_number, element) {
            return this.optional(element) || phone_number.length > 9 &&
                phone_number.match(/^[0-9 . \/]+$/);
        }, 'Please specify a valid phone number');


        /**
         * Email validation method
         */
        $.validator.addMethod('emailValidation', function (email, element) {
            var differentEmail = true;
            var $emails = $('.email');
            if ($emails.length > 1) {
                $emails.each(function () {
                    if ($(this).attr('name') !== $(element).attr('name') && $(this).val() === $(element).val())
                        differentEmail = false;
                });
            }
            return differentEmail;
        }, 'Please set different e-mail address for each traveler.');

        /**
         * Clear wizard data after booking a trip
         */
        function clearView() {
            $('#persons_nr').val('1');
            $('.first_name').val('');
            $('.last_name').val('');
            $('.city').val('');
            $('.email').val('');
            $('.phone_number').val('');
            $('#card_number').val('');
            $('#cvv').val('');
            $('#card_holder_first_name').val('');
            $('#card_holder_last_name').val('');
            $('#card_holder_payment').val('');
            $('#id_client').val('');
            $('#email_client').val('');
            $('.traveler-info-extra').empty();
            $('#travelers').html('');
        }

        /**
         * Get trip details only on trip route
         */
        // if (window.location.pathname.search('/trip/') !== -1) {
        //     loadTrip();
        // }
        /**
         * Get new-trip details only on trip route
         */
        if (window.location.pathname.search('/trip/') !== -1) {
            loadTrip();
            setTimeout(function () {
                getSpecificTripDetails();
                addCollapsibles();
                addTabs();
                addTabArrows();
                detectWindowResize();
                // detectWindowScroll();
                addVideo();
                // navMobile();
                slidersMobile();
                // navFix();
                spotSticky();
                addSlider('test', 3);
                book();
                saveSpot();
                headerBottomDropdowns();
                addSlider('header', 1);
                addEventListenerForTripDates();
                addEventListenerForTripsDepart();
                // addEventListenerForPickupPoints();
            }, 1000);

        }

        if (window.location.pathname === '/') {
            addSlider('homepage-slider', 3);
        }

        setTimeout(function () {
            detectWindowScroll();
            navMobile();
            navFix();
        }, 1000);

        /**
         * Get trip details when departure location changes
         */
        $(document).on('change', '.select-departure-location', function () {
            $('#tripsContent').empty();
            var locationId = $(this).val(),
                tripId = $('#tripId').val();

            if (locationId != '') {
                initTripDates(tripId, locationId);
            }
        });

        /**
         * Clone traveler form if nr of persons changes
         */
        $(document).on('change', '#persons_nr', function () {
            var clone, travelerNr,
                cloneContainer = $('.traveler-info-extra'),
                travelerInfo = $('.traveler-info');

            cloneContainer.empty();

            for (var i = 1; i < parseInt($(this).val()); i++) {
                travelerNr = i + 1;
                clone = travelerInfo.last().clone();
                clone.find('input').val('');

                clone.find('input.first_name').attr('name', 'prenume_client[' + i + ']');
                clone.find('input.last_name').attr('name', 'nume_client[' + i + ']');
                clone.find('input.email').attr('name', 'email[' + i + ']');
                clone.find('input.phone_number').attr('name', 'telefon[' + i + ']');
                clone.find('input.city').attr('name', 'us_city[' + i + ']');
                clone.find('select.states').attr('name', 'id_us_state[' + i + ']');

                cloneContainer.append("<p style='margin-top: 10px;'><strong>Traveler " + travelerNr + "</strong></p><hr>").append(clone);

                setTimeout(function () {
                    $('.traveler-info-extra .phone_number').each(function () {
                        $(this).rules('add', {
                            phoneValidation: true,
                        });
                    });
                    $('.traveler-info-extra .email').each(function () {
                        $(this).rules('add', {
                            emailValidation: true,
                        });
                    });
                }, 1000);
            }
        });

        /**
         * Get trip dates based on first date and departure location id
         *
         * @param tripId
         * @param locationId
         */
        function initTripDates(tripId, locationId) {
            var data = {
                locationId: locationId,
                tripId: tripId
            };

            $.ajax({
                type: 'POST',
                url: '/get-date-for-departure-location',
                data: data,
                success: function (data) {
                    if (data.status == 'success') {
                        //window.location.href = '/trip/' + tripId + '/' + data.data + '/' + locationId;
                        $('#currentDate').val(data.data);
                    }
                }
            });
        }

        function loadTrip() {
            var locationId = $('#locationId').val(),
                currentDate = $('#currentDate').val(),
                tripId = $('#tripId').val();
            $.ajax({
                type: 'GET',
                url: '/get-trips-from-specific-location/trip/' + tripId + '/date/' + currentDate + '/departure/' + locationId,
                success: function (data) {
                    if (data.status == 'success') {
                        Website.init();
                        $('#tripsContent').append(data.data);
                        Website.init();
                        setTimeout(function () {
                            loadTripPage();
                        }, 1000);

                        var trips = $('.js-available-spots').text();
                        if (trips == 0) {
                            $('.js-available-spots-book').hide();
                        } else {
                            $('.js-available-spots-book').show();
                        }

                        $('.js-fbq-save-spot').click(function () {
                            if (!$('#trip_save_spot').attr('disabled')) {
                                $('#trip_save_spot').val(1);

                                updatePayment();
                            }
                        })

                        $('.js-fbq-book-now').click(function () {
                            if (!$('#trip_save_spot').attr('disabled')) {
                                $('#trip_save_spot').val(0);
                                updatePayment();
                            }
                        })
                    }
                }
            });
        }

        function formatDate(date) {
            var parts = date.split('-');
            var mydate = new Date(parts[0], parts[1] - 1, parts[2]);


            var year = mydate.getFullYear();
            var day = mydate.getDate();
            var month = mydate.getMonth();
            var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
            return day + ' ' + months[month] + ' ' + year;
        }

        function refreshTripData(trip, availableSpots) {
            if (availableSpots <= 0) {
                $('.js-available-spots-book').hide();
            } else {
                $('.js-available-spots-book').show();
            }

            if (availableSpots > 10) {
                $('.js-available-spots').text('10+');
            } else if (availableSpots < 0) {
                $('.js-available-spots').text(0);
            } else {
                $('.js-available-spots').text(availableSpots);
            }

            var dropdownSpots = availableSpots >= 5 ? 5 : availableSpots;

            if (dropdownSpots != $('#persons_nr option').length - 1) {
                $('#persons_nr option:not(:first-child)').remove();

                for (var i = 1; i <= dropdownSpots; i++) {
                    var option = document.createElement("option");
                    $(option).attr("value", i);
                    option.innerText = i;
                    $('#persons_nr').append(option);
                }

            }

            $('input.js-data-inceput').val(trip.data_inceput);
            $('.js-data-inceput:not(input)').text(trip.data_inceput);

            $('input.js-location').val(trip.location.location_name);
            $('.js-location:not(input)').text(trip.location.location_name);

            $('input.js-id-produs').val(trip.id_produs);

            $('.js-duration').text(calcDaysBetweenTwoDate(trip.data_inceput, trip.data_sfarsit))
        }

        function calcDaysBetweenTwoDate(a, b) {
            var oneDay = 24 * 60 * 60 * 1000;
            var firstDate = new Date(a);
            var secondDate = new Date(b);
            return Math.round(Math.abs((firstDate - secondDate) / oneDay)) + 1;
        }

        function onChangeTripDepart() {
            var locationId = $('#locationId').val(),
                currentDate = $('#currentDate').val(),
                tripId = $('#tripId').val();
            $.ajax({
                type: 'GET',
                url: '/get-trips-from-specific-location/trip/' + tripId + '/date/' + currentDate + '/departure/' + locationId + '/true',
                success: function (data) {
                    if (data.status == 'success') {
                        var currentTrip = data.data.trip.dates.find(function (date) {
                            return (date.data_inceput == currentDate) && (date.location.id_location == locationId);
                        });

                        $('.js-trip-date li.active').removeClass('active');
                        $('.js-trip-depart-from li.active').removeClass('active');
                        var datesList = data.data.tripsDates;
                        var dates = $('.js-trip-date');
                        dates.empty();
                        for (var i = 0; i < datesList.length; i++) {
                            var li = document.createElement("li");
                            $(li).attr("data-value", datesList[i].data_inceput);
                            li.innerText = formatDate(datesList[i].data_inceput) + " - " + formatDate(datesList[i].data_sfarsit);
                            dates.append(li);
                        }
                        addEventListenerForTripDates();
                        $('.js-trip-date li[data-value="' + currentDate + '"]').addClass('active');
                        $('.js-trip-depart-from li[data-value="' + locationId + '"]').addClass('active');

                        // var pickupPointsList = data.data.pickupPoints;
                        // var pickupPoints = $('.js-trip-pickup-point');
                        // pickupPoints.empty();
                        // for (i = 0; i < pickupPointsList.length; i++) {
                        //     li = document.createElement("li");
                        //     $(li).attr("data-value", pickupPointsList[i].id_point);
                        //     li.innerText = pickupPointsList[i].pickup_point;
                        //     pickupPoints.append(li);
                        // }
                        // addEventListenerForPickupPoints();

                        refreshTripData(currentTrip, data.data.availableSpots);
                    } else if (data.status == 'error') {
                        initTripDates(tripId, locationId);
                        onChangeTripDepart();
                    }
                },
                error: function (error) {
                    console.log(error);

                }
            });
        }


        /**
         * Get trip details when departure location changes
         */
        function onChangeTripDates() {
            var locationId = $('#locationId').val(),
                currentDate = $('#currentDate').val(),
                tripId = $('#tripId').val();
            $.ajax({
                type: 'GET',
                url: '/get-trips-from-specific-location/trip/' + tripId + '/date/' + currentDate + '/departure/' + locationId + '/true',
                success: function (data) {
                    if (data.status == 'success') {
                        var currentTrip = data.data.trip.dates.find(function (date) {
                            return (date.data_inceput == currentDate) && (date.location.id_location == locationId);
                        });
                        $('.js-trip-date li.active').removeClass('active');
                        $('.js-trip-date li[data-value="' + currentDate + '"]').addClass('active');

                        refreshTripData(currentTrip, data.data.availableSpots);
                    } else {
                        console.log(data);
                    }
                },
                error: function (error) {
                    console.log(error);
                }
            });
        }

        function initStripe(callback) {
            var date = $("#expiration_date").val().split('-');
            var month = date[1];
            var year = date[0];
            var name = $('#card_holder_first_name').val() + " " + $('#card_holder_last_name').val();
            Stripe.setPublishableKey(stripe_pb_key);
            Stripe.createToken({
                number: $('#card_number').val(),
                cvc: $('#cvv').val(),
                exp_month: month,
                exp_year: year,
                name: name
            }, function stripeResponseHandler(status, response) {
                if (response.error) {
                    var buttonPrev = $('.actions > ul > li').first();
                    $('.alert-message').removeClass('alert-warning alert-success').addClass('alert-danger').show();
                    $('.alert-text').html(response.error.message);
                    buttonPrev.show();

                } else {
                    // token contains id, last4, and card type
                    var token = response['id'];
                    // insert the token into the form so it gets submitted to the server
                    form.append("<input type='hidden' name='stripeToken' id='stripe_token' value='" + token + "'/>");
                    // and submit
                    callback();
                }
            });
        }

        function initTimeOut(ms) {
            var $bookNowButton = $('a[href="#bookNowModal"]'),
                $modal = $('#bookNowModal');
            $bookNowButton.on('click', function () {
                setTimeout(function () {
                    $modal.addClass('time-out');
                }, ms);
            });
        }

        function addEventListenerForTripDates() {
            $('.js-trip-date li').on('click', function () {
                $('#currentDate').val($(this).data("value"));
                onChangeTripDates();
            });
        }


        function addEventListenerForTripsDepart() {
            $('.js-trip-depart-from li').on('click', function () {
                $('#locationId').val($(this).data("value"));
                onChangeTripDepart();
            });
        }

        function addEventListenerForPickupPoints() {
            $('.js-trip-pickup-point li').on('click', function () {
                $('#pickupId').val($(this).data("value"));
                $('.js-trip-pickup-point li').removeClass('active');
                $(this).addClass('active');
            });
        }

        function updatePayment() {
            var payment = $('#card_holder_payment'),
                price = $('#trip_price').val(),
                saveSpot = $('#trip_save_spot').val(),
                saveSpotVal = $('#trip_save_spot_value').val(),
                noPersons = $('#persons_nr').val(),
                totalSaveSpot = saveSpotVal * noPersons,
                totalPrice = price * noPersons;

            if (saveSpot > 0) {
                payment.attr('max', totalSaveSpot).val(totalSaveSpot);
            } else {
                payment.attr('max', totalPrice).val(totalPrice);
            }

            $('.total-payment').html(totalPrice);
        }

        function addCollapsibles() {
            var $all = $('.collapsible');
            for (var i = 0; i < $all.length; i++) {
                if ($($all[i]).hasClass('active')) {
                    $($all[i]).next().slideDown(200);
                }
                $($all[i]).on("click", function () {
                    if ($(this).hasClass('active')) {
                        $(this).next().slideUp(200);
                    } else {
                        $(this).next().slideDown(200);
                    }
                    $(this).toggleClass("active");
                });

                var $li_all = $($all[i]).next().children().children();
                for (var j = 0; j < $li_all.length; j++) {
                    $($li_all[j]).on('click', function () {
                        if (!($(this.parentElement).hasClass('js-trip-date') || $(this.parentElement).hasClass('js-trip-depart-from'))) {
                            var siblings = $(this).siblings();
                            for (var s = 0; s < siblings.length; s++) {
                                $(siblings[s]).removeClass('active');
                            }
                            $(this).toggleClass('active');
                        }
                    });
                }
            }
        }


        function addTabs() {
            var $all = $('.tab-buttons li');
            if ($all.length > 0) {
                for (var i = 0; i < $all.length; i++) {
                    $($all[i]).on('click', function () {
                        var siblings = $(this).siblings();
                        for (var s = 0; s < siblings.length; s++) {
                            $(siblings[s]).removeClass('active');
                        }
                        $(this).addClass('active');
                        changeTabContent();
                    });
                }
            }

        }

        function changeTabContent() {
            var $contentId = $('.tab-buttons .active').attr('data-toggle');
            var siblings = $('.tab-content');
            for (var s = 0; s < siblings.length; s++) {
                $(siblings[s]).removeClass('active');
            }
            $('#' + $contentId).addClass('active');
        }

        function detectWindowResize() {
            $(window).resize(function () {
                if ($(window).width() <= 768) {
                    addTabArrows();
                }
            });
        }

        function addTabArrows() {
            $('.js-panel-with-tabs .js-tab-back').remove('click');
            $('.js-panel-with-tabs .js-tab-forward').remove('click');

            if ($(window).width() <= 768) {
                $('.js-panel-with-tabs .tab-buttons li:nth-of-type(1)').show();
                $('.js-panel-with-tabs .tab-buttons li:nth-of-type(2)').show();
                $('.js-panel-with-tabs .tab-buttons li:nth-of-type(3)').show();
                $('.js-panel-with-tabs .js-tab-back').on('click', function () {
                    var $active = $('.js-panel-with-tabs .tab-buttons .active').get(0);
                    if ($('.tab-buttons li:first-of-type').get(0) !== $active) {
                        var $visibles = $('.js-panel-with-tabs .tab-buttons li:visible');
                        if ($visibles[0] === $active) {
                            $($visibles[2]).css('display', 'none');
                            $($visibles[0].previousElementSibling).show();
                        }
                        $($active).removeClass('active');
                        $($active.previousElementSibling).addClass('active');
                        changeTabContent();
                    }
                });
                $('.js-panel-with-tabs .js-tab-forward').on('click', function () {
                    var $active = $('.js-panel-with-tabs .tab-buttons .active').get(0);
                    if ($('.tab-buttons li:last-of-type').get(0) !== $active) {
                        var $visibles = $('.js-panel-with-tabs .tab-buttons li:visible');
                        if ($visibles[2] === $active) {
                            $($visibles[0]).css('display', 'none');
                            $($visibles[2].nextElementSibling).show();
                        }
                        $($active).removeClass('active');
                        $($active.nextElementSibling).addClass('active');
                        changeTabContent();
                    }
                });
            }
        }

        function addVideo() {
            $('.video-container button').on('click', function (ev) {
                $("#trip-video")[0].src += "&autoplay=1";
                ev.preventDefault();
                $(this).hide();
            });
        }

        function navMobile() {
            $('.js-nav-mobile').on('click', function () {
                var $all = $('.js-nav-mobile');
                for (var i = 0; i < $all.length; i++) {
                    if ($all[i] !== this) {
                        $($all[i].closest('.js-nav-mobile-tab')).removeClass('active');
                    }
                }
                $(this.closest('.js-nav-mobile-tab')).toggleClass('active');
                var self = this;
                if ($(this.closest('.js-nav-mobile-tab')).hasClass('active')) {
                    $(window).on('click', function (e) {
                        if (!$(e.target).is('.js-header, .js-header *')) {
                            $(self.closest('.js-nav-mobile-tab')).removeClass('active');
                            $(window).off('click');
                        }
                    });
                } else {
                    $(window).off('click');
                }
            });
        }

        function navFix() {
            if ($('.new-header')) {
                if (window.pageYOffset >= $('.new-header').get(0).offsetTop + 122) {
                    $('.new-header').addClass('fixed');
                } else {
                    $('.new-header').removeClass('fixed');
                }
            }

        }

        function spotSticky() {
            if ($('.js-new-trip-container').length && window.pageYOffset >= $('.js-new-trip-container').get(0).offsetTop) {
                $('.js-trip-spots').addClass('sticky');
            } else {
                $('.js-trip-spots').removeClass('sticky');
            }
        }

        function detectWindowScroll() {
            $(window).on('scroll', function () {
                navFix();
                spotSticky();
            });
        }

        function slidersMobile() {
            $('.js-sliders-mobile').on('click', function () {
                if ($(this.nextElementSibling).hasClass('active')) {
                    $(this.nextElementSibling).slideUp(200);
                } else {
                    $(this.nextElementSibling).slideDown(200);
                }
                $(this).toggleClass("active");
                $(this.nextElementSibling).toggleClass('active');


                var self = this;
                if ($(this.nextElementSibling).hasClass('active')) {
                    $(window).on('click', function (e) {
                        if (!$(e.target).is('.js-header-bottom, .js-header-bottom *')) {
                            $(self.nextElementSibling).slideUp(200);
                            $(self.nextElementSibling).removeClass('active');
                            $(window).off('click');
                        }
                    });
                } else {
                    $(window).off('click');
                }
            });
        }

        function headerBottomDropdowns() {
            $('.js-trip-select.dropdown').on('click', function () {
                $('.js-trip-select .dropdown-menu:visible').slideUp(200);

                if ($($(this).find('.dropdown-menu')).is(':visible')) {
                    $($(this).find('.dropdown-menu')).slideUp(200);
                } else {
                    $($(this).find('.dropdown-menu')).slideDown(200);
                    var self = this;
                    $(window).on('click', function (e) {
                        if (!($(e.target).is($(self)) || $($($(e.target).closest('.dropdown')).get(0)).is(self))) {
                            $($(self).find('.dropdown-menu')).slideUp(200);
                            $(window).off('click');
                        }
                    });
                }

            });
        }

        $(document).tooltip({
            position: {
                my: "left bottom-20",
                at: "center top",
                using: function (position) {
                    $(this).css(position);
                }
            }
        });
    });

    function addSlider(sliderId, slidesToShow) {
        $('#' + sliderId).slick({
            centerMode: true,
            centerPadding: '0',
            slidesToShow: slidesToShow,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: true,
                        centerMode: true,
                        centerPadding: '0',
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: true,
                        centerMode: true,
                        centerPadding: '0',
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    function loadTripPage() {
        $('.js-main-block').css('opacity', 1);
        setTimeout(function () {
            $('.js-hidden-block.js-show-1').css('opacity', 1);
            setTimeout(function () {
                $('.js-hidden-block.js-show-2').css('opacity', 1);
                setTimeout(function () {
                    $('.js-hidden-block.js-show-3').css('opacity', 1);
                    setTimeout(function () {
                        $('.js-hidden-block').css('opacity', 1);
                    }, 200);
                }, 200);
            }, 200);
        }, 1000);
    }

    function book() {
        $('.js-fbq-book-now').attr("onClick", "fbq('track', 'SubmitApplication');");
    }

    function saveSpot() {
        $('.js-fbq-save-spot').attr("onClick", "fbq('track', 'Schedule');");
    }

    function getSpecificTripDetails() {
        // getTripsFromSpecificLocation($tripId, $date, $locationId, $api = false)
    }
})();
